module.exports = __webpack_public_path__ + "static/img/qrcode2.65e40a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qrcode2.png
// module id = FTJB
// module chunks = 0